import AuthorImage from 'assets/resources/author.webp';
import AILiveSimImage from 'assets/logo.svg';

interface IAuthor {
  author: string;
  authorImage: string;
  linkedInAuthorLink: string;
}

type TAuthorsNames = 'Michael Haralson' | 'AILiveSim';

export const AUTHORS: Record<TAuthorsNames, IAuthor> = {
  'Michael Haralson': {
    author: 'Michael Haralson',
    authorImage: AuthorImage,
    linkedInAuthorLink: 'https://www.linkedin.com/in/michael-haralson-3b57583',
  },
  AILiveSim: {
    author: 'AILiveSim',
    authorImage: AILiveSimImage,
    linkedInAuthorLink: 'https://www.linkedin.com/company/ailivesim',
  },
};
